module.exports = __webpack_public_path__ + "static/media/iconlocationsm.9636ca6a.svg";